import React from "react";
import { Link } from "react-router-dom";
import activeSS from "../../../assets/product-active.png";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="active-call-to-action-wrapper">
      <div className="" id="callToAction">
        <div
          className="call-to-action-container text-center"
          style={{ backgroundImage: "url('../../assets/bg-pattern.svg')" }}
        >
          <div
            className="position-relative right-side-width"
            style={{ gap: "15px" }}
          >
            <h4 className="title_text">See Active in Action</h4>
            <p className="detail-info">
              Want to witness how Active can revolutionize your HR and payroll
              operations? Schedule a live demo and discover the power of
              streamlined, human-centered payroll software.
            </p>
            <Link
              to="/connect-with-us"
              className="btn-md btn-dark border-0"
              onClick={scrollHeader}
            >
              Contact Us
            </Link>
          </div>
          <div className="image-container">
            <img src={activeSS} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
